const ITEMS = [
  "Instant PDF & GoodNotes downloads",
  "Undated, reusable templates",
  "Study & budget systems",
  "Mindful habit trackers",
  "Original designs, made slowly",
];

const Bloom = () => (
  <svg width="16" height="16" viewBox="0 0 44 44" fill="none" className="mx-6 shrink-0 opacity-70" aria-hidden="true">
    <path
      d="M22 4C22 4 25.5 12.5 31.5 14C37.5 15.5 40 22 40 22C40 22 32.5 24 30.5 29.5C28.5 35 22 40 22 40C22 40 19.5 31.5 13.5 30C7.5 28.5 4 22 4 22C4 22 11.5 20 13.5 14.5C15.5 9 22 4 22 4Z"
      stroke="#4A6B5D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>
);

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="marquee overflow-hidden border-y border-sage/10 bg-sage-tint/70 py-3.5" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap font-serif text-sm italic tracking-[0.2em] text-sage-deep">
                {item}
                <Bloom />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
